import React, { useEffect, useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import InputField from '../../../../../component/form/FormInput';
import Button from '../../../../../component/ui/Button';
import { toast } from 'react-toastify';
import {
	createParentAccount,
	getParentAccount,
	UpdateParentAccount,
} from '../../../../../services/settings/accounting';

export default function CreateParentAccount({ isOpenModal, setIsOpenModal, id, getList }) {
	const [parentAccount, setParentAccount] = useState({
		account_name: '',
		description: '',
		status: false,
	});
	const [error, setError] = useState(null);
	const [loader, setLoader] = useState(false);

	const handleParentAccounts = async () => {
		if (
			!parentAccount.account_name ||
			parentAccount.account_name === null ||
			parentAccount.account_name === undefined
		) {
			setError('Please enter parent account name in the field');
			toast.error('Unable to create parent account. Please filled All fields');
		} else {
			try {
				setLoader(true);
				const body = {
					account_name: parentAccount.account_name,
					description: parentAccount.description,
					status: parentAccount.status ? 1 : 0,
				};
				var res;
				if (id) {
					res = await UpdateParentAccount(id, body);
				} else {
					res = await createParentAccount(body);
				}
				if (res.success) {
					toast.success(res.message);
					setIsOpenModal(false);
					getList();
				} else {
					toast.error(res.message || 'Something went wrong!');
				}
			} catch (error) {
				toast.error(error.response.data.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const getParentAccountDetails = async () => {
		try {
			const res = await getParentAccount(id);
			const data = {
				account_name: res.account_name || '',
				description: res.description || '',
				status: res.status !== null ? (res.status === 1 ? true : false) : false,
			};
			setParentAccount(data);
		} catch (err) {}
	};

	useEffect(() => {
		if (id) {
			getParentAccountDetails();
		}
	}, []);

	return (
		<Modal
			className="confirmatinBoxModal"
			title={id ? 'Edit Parent Account' : 'Add New Parent Account'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="col-12 py-3">
				<InputField
					label="Parent Account Name"
					name="parent_account_name"
					placeholder="Parent Account Name"
					type="text"
					required={true}
					value={parentAccount.account_name}
					onChange={(value) => {
						setParentAccount((prev) => ({
							...prev,
							account_name: value,
						}));
						if (value) {
							setError(null);
						} else {
							setError('Please enter parent account name');
						}
					}}
					error={error}
				/>
			</div>
			<div className="col-12 py-2">
				<InputField
					name="description"
					type="text"
					placeholder="Description"
					label="Description"
					onChange={(value) => {
						setParentAccount((prev) => ({
							...prev,
							description: value,
						}));
					}}
					error={error}
				/>
			</div>
			<div className="d-flex gap-3 align-items-center py-3">
				<div className="fs-4 fw-bold text-dark">Status</div>
				<div className="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						checked={parentAccount.status}
						id="parent_account_status"
						onChange={(e) => {
							setParentAccount((prev) => ({
								...prev,
								status: !parentAccount.status,
							}));
						}}
					/>
				</div>
			</div>
			<div className="d-flex align-items-center justify-content-end gap-4 my-2">
				<Button
					type="button"
					button={`${id ? 'Update' : 'Save'}`}
					className="mt-0 px-5 btn-primary relative"
					loader={loader}
					disabled={loader}
					onClick={() => handleParentAccounts()}
				/>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-3 py-2 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
			</div>
		</Modal>
	);
}
